<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("datasubject-right.new") }}</span>
      </h2>
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('datasubject-right.name')"
      />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "workspaceDatasubjectRight";

export default {
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$emit("onFormSave");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
